export default class Tabs {
	constructor() {
		this.init();
	}

	/**
	 * Can safely be called multiple times
	 */
	init() {
		const tabs = Array.from(document.querySelectorAll<HTMLElement>('.tabs'));
		tabs.forEach(tab => {
			if (tab.getAttribute('data-tabs-initialized') === 'true') {
				return;
			}
			window.addEventListener('popstate', () => {
				const firstTab = tab.querySelector<HTMLInputElement>(".tabList__fieldset input");
				const name = firstTab?.name;
				if (!name) {
					return;
				}
				const params = new URLSearchParams(document.location.search);
				const tabValue = params.get(name) ?? firstTab.value;
				for (const t of tab.querySelectorAll<HTMLInputElement>(".tabList__fieldset input")) {
					if (t.value === tabValue) {
						if (!t.checked) {
							this.activate(this.deriveButtonFromInput(t));
						}
					} else {
						t.checked = false;
					}
				}
			});

			const tabButtons = tab.querySelectorAll('[role="tab"]');
			tabButtons.forEach(button => {
				// Click handler
				button.addEventListener('click', e => this.handleTabClick(e));
				
				// Ensure activated tab's panel is activated
				if (button.getAttribute('aria-selected') === 'true' && button instanceof HTMLElement) {
					this.activate(button);
				}
			});

			tab.setAttribute('data-tabs-initialized', 'true');
		});
	}

	deriveButtonFromInput(input: Element|string): HTMLElement {
		if (typeof input !== 'string') {
			input = input.id;
		}
		// The id of the button is just the id of the radio without the trailing "-radio"
		return document.getElementById(input.substring(0, input.length - 6));
	}

	handleTabClick(event: Event) {
		this.activate(event.currentTarget as HTMLElement);
	}
	activate(currentButton: HTMLElement) {
		const tabs = currentButton.closest('.tabs');

		const tabButtons = Array.from(tabs.querySelectorAll<HTMLElement>('[role="tab"]'));
		const tabPanels = Array.from(tabs.querySelectorAll<HTMLElement>('[role="tabpanel"]'));

		tabButtons.forEach(tab => tab.setAttribute('aria-selected', tab === currentButton ? 'true' : 'false'));
		tabPanels.forEach(panel => panel.hidden = panel.getAttribute('aria-labelledby') !== currentButton.id);

		// Select radio, if one exists
		const radio = document.getElementById(currentButton.id + '-radio') as HTMLInputElement;
		if (radio) {
			radio.checked = true;
		}

		tabs.dispatchEvent(new CustomEvent('tab-change'));
	}
}
